.container {
  position: relative;
  min-width: 0;
}

.lists {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 2rem;
}

.column {
  min-width: 12rem;
}

.groupItem {
  cursor: pointer;
  margin-bottom: 0.5rem;
}
